<template>
  <div :class="['home', `display-${display}`]">
    <h1 class="headline left" v-if="playoutDevice">
      <span>{{ playoutDevice.pool.title }}</span>
      <span class="gradient"></span>
      <span class="dodge">{{ playoutDevice.pool.title }}</span>
    </h1>

    <div class="logo">
      <img src="/static/hbsc-flag_3d.png" class="hertha-logo" />
    </div>

    <posts
      v-if="devicePool"
      :devicePool="devicePool"
      @changeDisplay="changeDisplay"
    />
  </div>
</template>

<script>
import Posts from '@/components/Posts';
import gql from 'graphql-tag';

const GET_PLAYOUT_DEVICE = gql`
  query PlayoutDevice($slug: String!) {
    playoutDevice(slug: $slug) {
      id
      name
      width
      height
      pool {
        __typename
        id
        title
        search
        posts_per_chunk
        duration_per_chunk
        font_size
        show_images
        crop_images
        arrangement
        geocode
        lng
        lat
        geo_radius
        sponsor_interval
        posts {
          __typename
          id
          source_ref
          order
          data
          user
        }
      }
    }
  }
`;

export default {
  name: 'playoutDevice',
  components: {
    Posts
  },

  data() {
    return {
      display: null
    };
  },

  methods: {
    showUser() {
      this.showUsername = true;
    },

    hideUser() {
      this.showUsername = false;
    },

    changeDisplay(display) {
      this.display = display;
    }
  },

  computed: {
    slug() {
      return this.$route.params.slug ? this.$route.params.slug : false;
    },

    devicePool() {
      return this.playoutDevice ? this.playoutDevice.pool : false;
    }
  },

  apollo: {
    playoutDevice: {
      query: GET_PLAYOUT_DEVICE,
      pollInterval: 1000 * 5,
      variables() {
        return {
          slug: this.slug
        };
      }
    }
  }
};
</script>

<style lang="scss">
h1.headline {
  position: fixed;
  top: 10vh;
  width: 100%;
  text-align: center;
  font-size: 15vh;
  color: #fff;
  font-weight: 400;
  margin: 0;
  z-index: 0;
  font-family: 'Neon Glow';
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transform: translateY(-25vh);
  transition: all 0.5s ease-in-out;

  background: linear-gradient(
    115deg,
    rgba(6, 227, 250, 1) 54%,
    rgba(255, 255, 255, 1) 98%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: blur(0.07vh) brightness(200%);

  text-shadow: 0 0 10px rgba(255, 255, 255, 0.2);

  animation: flicker 2s linear infinite;

  .display-sponsor & {
    transform: translateY(0);
  }

  .dodge {
    text-align: center;
    background: radial-gradient(circle, white, black 70%) left top / 5% 50%;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    filter: blur(0.5vh);
    -webkit-background-clip: text;
    mix-blend-mode: color-dodge;
    animation: dodge-area 20s linear infinite;
  }
}

@keyframes dodge-area {
  0% {
    background-position: left top;
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    background-position: right bottom;
    opacity: 0.5;
  }
}

@keyframes flicker {
  0% {
    opacity: 0.8;
  }

  2% {
    opacity: 1;
  }
  8% {
    opacity: 0.7;
  }
  9% {
    opacity: 1;
  }
  12% {
    opacity: 0.8;
  }
  20% {
    opacity: 1;
  }
  25% {
    opacity: 0.8;
  }
  30% {
    opacity: 1;
  }

  70% {
    opacity: 0.7;
  }

  72% {
    opacity: 0.7;
  }

  77% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}

.logo {
  position: fixed;
  top: 5vh;
  right: 2vh;
  width: 8vw;
  height: 12vh;
  z-index: 10;
  transform: translateX(10vw);
  transition: all 0.7s ease-in-out;

  .display-posts & {
    transform: translateX(0);
  }

  img {
    width: auto;
    height: 100%;
  }
}
</style>
